// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"ceff40b6","2":"88ab7ad5","156":"b61865ba","207":"8b6088bd","233":"cc94415b","282":"cae8a87f","349":"318f4d6b","478":"d7b7f271","480":"f3de2c18","558":"4fcb9496","596":"7d4fc594","667":"b18a81a5","871":"a7477e3d"}[chunkId] + ".chunk.js";
};